export default "__VITE_ASSET__b37bcf12__"